export default __webpack_public_path__ + "static/media/pm-logo@2x-noimage.489f4341.png";